
import { ErrorMessages } from "../../common/CommonExport";
import { setEmployeeList } from "../../redux/slices/employeeListSlice";
import { DataType } from "../../services/apiInterfaceType/apiInterfaceType";

import { AxiosResponse, AxiosError } from 'axios';

import { ApiError, DashboardDataItem, EmpInitValuesType, FilterOption, RawEmployeeData, ReformedEmployeeData, StepData } from "./DashBoardHelperTypes";


import { PayloadAction } from '@reduxjs/toolkit';

export const getCurrentMonth = () => {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentDate = new Date();
    return months[currentDate.getMonth()].substring(0, 3);
};

export const sortEventData = (dashboardData: DashboardDataItem[]) => {
    return [...dashboardData].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        const monthA = dateA.getMonth();
        const dayA = dateA.getDate();
        const monthB = dateB.getMonth();
        const dayB = dateB.getDate();
        return monthA === monthB ? dayA - dayB : monthA - monthB;
    });
};

export const isObjectEmpty = (obj: Record<string, unknown>) => {
    for (const key in obj) {
        if (key !== 'nextProbationEndDate') {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                if (!isObjectEmpty(obj[key] as Record<string, unknown>)) {
                    return false;
                }
            } else if (!obj[key]) {
                return false;
            }
        }
    }
    return true;
};

export const empInitValues: EmpInitValuesType = {
    nextProbationEndDate: '',
    firstName: '',
    lastName: '',
    officialEmail: '',
    dateOfJoin: '',
    personalEmail: '',
    organisationId: '1',
    designation: {
        designationId: '',
    },
    department: {
        departmentId: '',
    },
    status: {
        statusId: '',
    },
    reportingManager: {
        employeeId: '',
    },
    // initiationManager: {
    //     employeeId: '',
    // },
    employeeType: {
        employeeTypeId: '',
    },
};

export const empFilter: FilterOption[] = [
    {
        text: 'All Employees',
        value: 'All Employees'
    },
    {
        text: 'Probation',
        value: 'Probation',
    },
    {
        text: 'Confirmed',
        value: 'Confirmed',
    },
    {
        text: 'Past Employees',
        value: 'Past Employees',
    },
    {
        text: 'Appraisal Due',
        value: 'Appraisal Due',
    },
    {
        text: 'Active Employees',
        value: 'active',
    },
    {
        text: 'Notice Period',
        value: 'Notice Period',
    },
];

export const setDateFormat = (originalDateString: string) => {
    const originalDate = new Date(originalDateString);
    const year = originalDate.getUTCFullYear();
    const month = (originalDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = originalDate.getUTCDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
};

export const filterTakeUnique = (reformedEmployeeData: ReformedEmployeeData[], type: keyof ReformedEmployeeData) => {
    const unique = Array.from(new Set(reformedEmployeeData?.map((item) => item[type]))) ?? [];
    const uniqueWithNone = unique?.reduce((result: FilterOption[], item) => {
        const newItem = {
            text: item ?? 'None',
            value: item,
        };

        if (newItem.text === 'None') {
            result.push(newItem);
        } else {
            result.unshift(newItem); // Add to the beginning of the array
        }

        return result;
    }, []);

    return uniqueWithNone;
};


export const initLoadData = (dashboardData: { allEmployees: RawEmployeeData[] }, setAllFilterValues: (values: Record<string, FilterOption[]>) => void, setEmployeeData: (data: ReformedEmployeeData[]) => void, setEmployeeDataSearch: (data: ReformedEmployeeData[]) => void, dispatch: ((action: PayloadAction<ReformedEmployeeData[]>) => void) | boolean = false) => {

    const reformedEmployeeData = dashboardData?.allEmployees?.map((item, index: number) => ({
        employeename: `${item?.firstName} ${item?.lastName}`,
        doj: setDateFormat(item?.dateOfJoin),
        grade: item?.gradeName,
        designation: item?.designationName,
        dept: item?.departmentName,
        reportingTo: item?.reportingManagerName,
        status: item?.statusName,
        key: item?.employeeId,
        employeeTypeId: item?.employeeTypeId,
        profileUrl: item?.profileUrl,
        reviewStatus: item?.reviewStatus,
        officialMailId: item?.officialMailId,
        relievingDate: item?.relievingDate,
        dateOfBirth: item?.dateOfBirth,
        employeeCode: item?.employeeCode,


    })) ?? [];
    setAllFilterValues({
        grades: filterTakeUnique(reformedEmployeeData, 'grade'),
        designation: filterTakeUnique(reformedEmployeeData, 'designation'),
        dept: filterTakeUnique(reformedEmployeeData, 'dept'),
        reportingTo: filterTakeUnique(reformedEmployeeData, 'reportingTo'),
        status: empFilter,
    });
    setEmployeeData(reformedEmployeeData);
    setEmployeeDataSearch(reformedEmployeeData);
    if (dispatch && typeof dispatch === 'function')
        dispatch(setEmployeeList(reformedEmployeeData));
};

export const employeeFilterApiCall = async (value: string | null, EmployeeFilter: (query: string, params: unknown) => Promise<AxiosResponse | AxiosError>, setAllFilterValues: (values: Record<string, FilterOption[]>) => void, setEmployeeData: (data: ReformedEmployeeData[]) => void, setEmployeeDataSearch: (data: ReformedEmployeeData[]) => void, setLoader: (loading: boolean) => void, setPopModal?: (show: boolean) => void, setmodalButtonShow?: (show: boolean) => void, setModalErrMessage?: (msg: string) => void, setModalResponse?: (response: string) => void, handleClosePopUpModal?: () => void) => {
    setLoader(true)
    try {
        const paramFalse: Object = { isDashboardRefresh: false, employeeDashboardFilterDto: { departmentNames: [], designationNames: [], gradeNames: [], status: value ?? 'All Employees' } };
        const res = await EmployeeFilter('', paramFalse) as AxiosResponse;
        setLoader(false)
        initLoadData(res?.data?.data, setAllFilterValues, setEmployeeData, setEmployeeDataSearch);
    } catch (err: unknown) {
        const error = err as ApiError;
        // triggerNotification('error', '', error?.response?.data?.status?.message ?? ErrorMessages.somethingWentWrong, 'topRight');
        if (setPopModal) setPopModal(true);
        if (setmodalButtonShow) setmodalButtonShow(false)
        if (setModalErrMessage) setModalErrMessage(error?.response?.data?.status?.message ?? ErrorMessages.somethingWentWrong)
        if (setModalResponse) setModalResponse('error')
        setTimeout(() => {
            setLoader(false)

            if (handleClosePopUpModal) handleClosePopUpModal();
        }, 1500)
    }
};

export const handleCurrentStep = (data: StepData[]) => {
    const descriptions = new Set();
    let result = 0;
    for (const item of data) {
        descriptions.add(item.description);
        if (descriptions.has('Employee information saved') && descriptions.has('Document sent') && descriptions.has('Document signed off')) {
            result = 3;
        } else if (descriptions.has('Employee information saved') && descriptions.has('Document sent')) {
            result = 2;
        } else if (descriptions.has('Employee information saved')) {
            result = 1;
        }
    }
    return result;
};

export const handleExpand = (record: DataType, documentStatus: (query: string, body: unknown, params: object) => Promise<AxiosResponse | AxiosError>, setExpandedData: (data: unknown) => void, setExpandedRowKey: (key: string | null) => void, expandedRowKey: string | null, setLoader: (loading: boolean) => void) => {
    setLoader(true)
    const pathParams = {
        id: record.key,
        end: 'document-status',
    };
    documentStatus('', {}, pathParams)
        .then((res: AxiosResponse | AxiosError) => {

            // setCurrentStep(result);
            if ('data' in res) {
                setExpandedData(res?.data);
            }
            if (record.key && expandedRowKey !== record.key) setExpandedRowKey(record.key as string);
            setLoader(false)
        })
        .catch((err: AxiosError) => {
            setLoader(false)
            console.log(err);
        });
};

export const searchEmployeeByName = (data: ReformedEmployeeData[], searchTerm: string) => {
    const normalizedSearchTerm = searchTerm?.toLowerCase().trim();


    if (!normalizedSearchTerm) return data;

    const nameMatches = data.filter((record) =>
        record.employeename?.toLowerCase().includes(normalizedSearchTerm)
    );

    const reportingMatches = data.filter(
        (record) =>
            !nameMatches.includes(record) &&
            record.reportingTo?.toLowerCase().includes(normalizedSearchTerm)
    );

    const otherMatches = data.filter((record) => {
        const grade = record.grade
        const dept = record.dept
        const designation = record.designation
        const doj = record.doj

        return (
            !nameMatches.includes(record) &&
            !reportingMatches.includes(record) &&
            (grade?.toLowerCase().includes(normalizedSearchTerm) ||
                dept?.toLowerCase().includes(normalizedSearchTerm) ||
                designation?.toLowerCase().includes(normalizedSearchTerm) ||
                doj?.toLowerCase().includes(normalizedSearchTerm))
        );
    });

    return [...nameMatches, ...reportingMatches, ...otherMatches];
};
